/*
 * @Author: your name
 * @Date: 2022-03-23 11:45:05
 * @LastEditTime: 2022-03-23 14:18:31
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /h5-new-media/src/page/madePlanV3/helper/tool.js
 */
export const compare = (prop, align) => {
  return (a, b) => {
    const value1 = a[prop];
    const value2 = b[prop];
    if (align == "positive") {
      // 升序
      return new Date(value1) - new Date(value2);
    } else if (align == "inverted") {
      // 倒叙
      return new Date(value2) - new Date(value1);
    }
  };
};
export default compare;
